import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../assets/css/yousign.css";

export default function YouSign({
  signatureLink,
  endSignatureProcess,
  delegation,
}) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const handleSignIn = () => {
    endSignatureProcess();
  };

  useEffect(() => {
    if (!delegation.digitalSignLink) return;
    if (delegation.digitalSignLink === null) return;

    // Avvio caricamento Yousign
    eval(
      "const yousign = new Yousign({signatureLink: delegation.digitalSignLink,iframeContainerId: 'iframe-container',isSandbox: true,}); yousign.onSuccess((data) => {console.log('YouSign: documento firmato con successo.'); handleSignIn()});",
    );

    // Controllo se l’iframe è stato aggiunto al DOM
    const interval = setInterval(() => {
      const iframe = document.querySelector("#iframe-container iframe");
      if (iframe) {
        setLoading(false);
        clearInterval(interval);
      }
    }, 200);

    return () => clearInterval(interval);
  }, [delegation.digitalSignLink]);

  return (
    <div className="yousign-container">
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.33)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 99999,
          }}
        >
          <CircularProgress style={{ color: "#fff" }} />
        </div>
      )}

      <div id="iframe-container"></div>
    </div>
  );
}
